module.exports = __webpack_public_path__ + "static/img/slide3.aeec46f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/appInstavice/slide3.jpg
// module id = mp1+
// module chunks = 1